import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

const Button = (props) => {
  const className = classnames("button", props.additionalClassName);
  const icon = props.icon ? <i className={`button__icon ${props.icon}`} /> : null;
  const label = props.label ? props.label : null;
  const target = props.external ? "_blank" : "_self";

  return props.link ? (
    <Link
      className={className}
      to={props.link}
      target={target}
    >
      {label}
      {icon}
    </Link>
  ) : (
    <button className={className} onClick={props.onClick}>
      {label}
      {icon}
    </button>
  )
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/Button.js